import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        chatId: Number,
    };

    static targets = [
        'reasonSelect',
        'reasonTextarea',
        'sendCopyCheckbox',
        'invalidReasonSelect',
        'invalidReasonTextarea',
        'commentContainer',
        'commentTextarea',
    ];

    openModal() {
        $('#litigantRequestManagementCancelRequestModal').modal('show');

        this.reasonSelectTarget.addEventListener('change', () => {
            this.invalidReasonSelectTarget.style.display = 'none';
            this.reasonSelectTarget.classList.remove('is-invalid');
        });
    }

    onReasonSelectChange() {
        if (this.reasonSelectTarget.value === translations['direct_payment.cancel_reason.I found another lawyer outside Justifit']) {
            this.commentContainerTarget.classList.remove('d-none');
        } else {
            this.commentContainerTarget.classList.add('d-none');
        }
    }

    async submit() {
        showPreloader();
        event.preventDefault();
        let error = null;

        if (this.reasonSelectTarget.value === '') {
            this.invalidReasonSelectTarget.style.removeProperty('display');
            this.reasonSelectTarget.classList.add('is-invalid');

            hidePreloader();
            error = true;
        }

        if (4000 < this.reasonTextareaTarget.value.length) {
            this.invalidReasonTextareaTarget.style.removeProperty('display');
            this.reasonTextareaTarget.classList.add('is-invalid');

            hidePreloader();
            error = true;
        }

        if (error) {
            return;
        }

        const data = {
            reason: this.reasonSelectTarget.value,
            description: this.reasonTextareaTarget.value,
            email_confirmation: this.sendCopyCheckboxTarget.checked,
            comment: this.commentTextareaTarget.value,
        };

        fetch(routes['app_litigantrequestmanagement_cancellitigantrequest'], {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(json => {
                const container = document.querySelector('.litigant-management');
                if (container) {
                    container.innerHTML = json.html;
                } else {
                    window.location.reload();
                }
            })
            .finally(() => {
                hidePreloader();
                $('#litigantRequestManagementCancelRequestModal').modal('hide');
            });
    }
}
